
export default {
    Waiting : "waiting",
    Accepted : "accepted",
    Refused : "refused",
    Finished : "finished"
}
